import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { ReadingGradeLevels } from '@/components/shared/TextControlsToolbar/AIReadingLevelButton';
import ReadingLevelSelectComponent from './ReadingLevelSelect';

interface ReadingLevelSelectProps {
  aiReadingLevelEnabled?: boolean;
  classroomId?: string;
  readingLevel: ReadingGradeLevels;
  studentSeatId?: string;
}

const ReadingLevelSelect = (props: ReadingLevelSelectProps) => (
  <ReactQueryProvider>
    <ReadingLevelSelectComponent {...props} />
  </ReactQueryProvider>
);

export default ReadingLevelSelect;
